module.exports = __webpack_public_path__ + "img/failed.f1b3277e.png";